module.exports = __webpack_public_path__ + "img/20210903_101827.a9c967ca.jpg";